import {tgxApi} from "../../../app/tgxApi";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {
    getAuthorizationHeader, getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {downloadFile} from "../../../helpers/utils/FileUtils";


export const childAccountApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getAllChildAccount: build.query({
            query: (id) => {
                return {
                    url: `/ajax/child-account/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['childAccount'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getChildAccountById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-child-account-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['childAccount','childAccountById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createChildAccount: build.mutation({
            query: ({requestBody, id}) => {
                return {
                    url: `/ajax/create-child-account/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['childAccount'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Child Account")
            },
        }),
        updateChildAccount: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update-child-account/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['childAccount', 'childAccountById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Child Account")
            },
        }),

        deleteChildAccountById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-child-account/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['childAccount','childAccountById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Child Account");
            },
        }),

    }),
});


export const{useCreateChildAccountMutation,
useDeleteChildAccountByIdMutation,
useGetAllChildAccountQuery,
useGetChildAccountByIdQuery,
useUpdateChildAccountMutation}=childAccountApi